<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="group">
          <label>Sales</label>
          <AjaxSelect
            ref="ajaxSelect"
            v-model="sale"
            :api="`/api/companies/${companyId}/sales`"
            :query="{deliveryMethod: 'delivery', perPage: 5, augment: 'short', 'order-id': 'desc'}"
            :map-fn="(s) => `#${s.id}`"
            :allow-empty-search="true"
          />
        </div>
        <div class="buttons-action">
          <button class="btn btn-primary" @click="test('validate')">{{$t("validate")}}</button>
          <button class="btn btn-primary" @click="test('estimate')">{{$t("estimate")}}</button>
        </div>
        <div class="group" v-if="sale.id">
          <label>Sale data</label>
          <jsonViewer :value="sale"/>
        </div>
      </div>
      <div class="column">
        <div class="group" v-if="lastTest.response">
          <label>Test {{$t(lastTest.name)}}</label>
          <label>Request</label>
          <jsonViewer :value="lastTest.request"/>
          <label>Response</label>
          <jsonViewer :value="lastTest.response"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AjaxSelect from "@/components/tools/AjaxSelect";
import {Core} from "@/core/Core";
import JsonViewer from 'vue-json-viewer'

export default {
  name: "shipperSandbox",
  components: { AjaxSelect, JsonViewer },
  props: {
    config: Object,
    companyId: String
  },

  data() {
    return {
      sale: {id: null},
      lastTest: {
        type: null,
        request: null,
        response: null,
      }
    }
  },

  methods: {
    async test(name) {
      this.$store.commit('showSpinner', true);
      try {
        let url = name === 'validate' ? '/api/shipper-test/validate' : '/api/shipper-test/estimate';
        let requestData = JSON.parse(JSON.stringify({config: this.config, sale: this.sale}))
        let responseData = await Core.request("POST", url, requestData);
        this.lastTest.name = name;
        this.lastTest.request = requestData;
        this.lastTest.response = responseData;
      } catch (e) {
        console.log('error', e);
      }
      this.$store.commit('showSpinner', false);
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-action {
  margin-bottom: 10px;

  button {
    margin-right: 10px;
  }
}
</style>